export const ACCEPTED_FILE_EXTENSIONS = [
  '.JPG',
  '.JPEG',
  '.PNG',
  '.PDF',
  '.AI',
  '.EPS',
  '.GIF',
  '.BMP',
  '.PSD',
  '.WEBP',
  '.TIF',
  '.TIFF',
  '.AVIF',
  '.HEIC',
  '.HEIF'
];

export const FILE_EXTENSIONS = {
  'application/pdf': 'pdf',
  'application/postscript': 'ai',
  'application/vnd.dvb.ait': 'ait',
  'image/bmp': 'bmp',
  'image/gif': 'gif',
  'image/jpeg': 'jpeg',
  'image/png': 'png',
  'image/vnd.adobe.photoshop': 'psd',
  'image/x-ms-bmp': 'bmp',
  'image/webp': 'webp',
  'image/tiff': 'tiff',
  'image/avif': 'avif',
  'image/heic': 'heic',
  'image/heif': 'heif'
};

export const UNSUPPORTED_IMAGE_TYPES = [
  'application/coreldraw',
  'application/x-eva',
  'application/xml',
  'image/apng',
  'image/cgm',
  'image/cineon',
  'image/cpi',
  'image/dpx',
  'image/exr',
  'image/jp2',
  'image/pict',
  'image/svg+xml',
  'image/vnd.djvu',
  'image/vnd.dxf',
  'image/vnd.ms-photo',
  'image/x-freehand',
  'image/x-icon',
  'text/vnd.ascii-art',
  'video/x-anim'
];

export const UNSUPPORTED_VIDEO_TYPES = [
  'application/javascript',
  'application/vnd.apple.mpegurl',
  'application/x-mpegurl',
  'video/3gpp',
  'video/mp4',
  'video/mpeg',
  'video/ogg',
  'video/quicktime',
  'video/webm',
  'video/x-m4v',
  'video/ms-asf',
  'video/x-ms-wmv',
  'video/x-msvideo'
];

export const COLOR_MODES = {
  MONOCHROME: 'monochrome',
  PHOTO: 'photo',
  SPOT: 'spot'
};

export const MAXIMUM_DIMENSIONS = {
  LARGE: 800,
  SMALL: 400
};

export const MAXIMUM_FILE_SIZE = 5 * 1024 * 1024;
export const PRESIGNED_URL_MAX_FILE_SIZE = 20 * 1024 * 1024; // Bytes * KB * MB

export const MONOCHROME_COLOR_MAXIMUM = 2;

export const PRODUCT_COLOR_REMOVALS = ['White', 'Black'];

export const TRANSPARENT = 'transparent';

export const EXT_EXTRACTOR = fileName => /(?:\.([^.]+))?$/.exec(fileName)[1]; // https://stackoverflow.com/a/680982/13295205

export const MINIMUM_DPI = 120;

export const DEFAULT_CONTRAST = 200;
